import { Link } from "@/lib/nav";

import MetaSep from "@/components/meta-sep";
import { contractVatModeOf, currentTotalOf } from "@buildpy/core/modules/change-order/calc";
import { statementPath } from "@buildpy/core/modules/change-order/current-statement";
import { changeOrderStartBlock } from "@buildpy/core/modules/change-order/start-block";
import { extendAllowedFor } from "@buildpy/core/modules/change-order/transitions";
import ChangeOrderBlock from "@/modules/change-order/ui/change-order-block";
import ChangeOrderEditor from "@/modules/change-order/ui/change-order-editor";
import { prefillFromLog } from "@buildpy/core/modules/change-order/view";
import { PROJECT_LOG_KIND_LABEL } from "@buildpy/core/modules/project/types";
import type { ChangeOrderNewView } from "@buildpy/core/views/g2b/change-order-new";
import PageHeader from "@/shell/page-header";

// 변경공사 만들기 — 일지에서 오면(?log=) 제목·사유를 채우고 항목은 비운다.
const Page = ({ data }: { data: ChangeOrderNewView }) => {
  const { detail, project, changeOrders, sourceTrades, log } = data;
  const { contract } = detail;
  const prefill = log ? prefillFromLog(log) : null;

  const blocked = changeOrderStartBlock(contract, project?.project ?? null);

  return (
    <>
      <PageHeader
        meta={
          <span className="flex flex-wrap items-center gap-x-3 gap-y-3 md:gap-x-2 md:gap-y-1">
            <Link className="tap-target relative underline-offset-2 hover:underline" href={`/app/contracts/${contract.id}`}>
              계약 {contract.contract_no} · {contract.title}
            </Link>
            <MetaSep />
            <Link className="tap-target relative underline-offset-2 hover:underline" href={statementPath(contract.id)}>
              현재 내역서
            </Link>
          </span>
        }
        title="변경공사 만들기"
      />
      {blocked ? (
        <ChangeOrderBlock block={blocked} />
      ) : (
        <div className="max-w-2xl">
          <ChangeOrderEditor
            currentTotal={currentTotalOf(contract, changeOrders).current}
            extendAllowed={extendAllowedFor(project?.project.status)}
            initial={{
              title: prefill?.title ?? "",
              reason: prefill?.reason ?? "",
              source_log_id: prefill?.source_log_id ?? null,
              extend_days: null,
              items: [],
            }}
            mode={{ kind: "create", contractId: contract.id }}
            payments={detail.payments.map(({ id, seq, ratio_bp, amount, paid_at }) => ({ id, seq, ratio_bp, amount, paid_at }))}
            sourceLogLabel={log && prefill ? `${log.log_date} · ${PROJECT_LOG_KIND_LABEL[log.kind]}` : null}
            sourceTrades={sourceTrades}
            vatMode={contractVatModeOf(contract)}
          />
        </div>
      )}
    </>
  );
};

export default Page;
